
      <dx-drop-down-box class="gen-coklu-lookup"
        [(value)]="treeBoxValue"
        [inputAttr]="{ 'aria-label': 'Owner' }"
        [valueExpr]="valueExpr"
        [displayExpr]="displayExpr"
        [placeholder]="labelText"
        [showClearButton]="true"
        [dataSource]="treeDataSource"
        (onValueChanged)="onDropDownBoxValueChanged($event)"
        [(opened)]="isDropDownBoxOpened"
      >
        <div *dxTemplate="let data of 'content'">
          <dx-tree-view
            [dataSource]="treeDataSource"
            dataStructure="plain"
            [keyExpr]="valueExpr"
            selectionMode="multiple"
            showCheckBoxesMode="normal"
            [selectNodesRecursive]="false"
            [displayExpr]="displayExpr"
            [selectByClick]="true"
            (onContentReady)="onTreeViewReady($event)"
            (onItemSelectionChanged)="onTreeViewSelectionChanged($event)"
          >
          </dx-tree-view>
        </div>
      </dx-drop-down-box>

      <dx-popover *ngIf="showValuesPopoverOnHover"
        #popover
        [target]="'.gen-coklu-lookup'"
        [visible]="isPopoverVisible && !isDropDownBoxOpened && treeBoxDisplayValue?.length > 1"
        [position]="{ my: 'top', at: 'bottom', offset: '0 5' }"
        (onHiding)="isPopoverVisible = false"
      >
        <div *dxTemplate="let data of 'content'">
          <div style="width: max-content; padding: 12px;">
           <span *ngFor="let item of treeBoxDisplayValue" style="display:list-item;white-space: nowrap;margin-bottom:3px">
              {{item}}
           </span>
           </div>
        </div>
      </dx-popover>
          